/**
 * 数据项类型
 */
export var DataItemType;
(function (DataItemType) {
    /**
     * 短文本
     */
    DataItemType[DataItemType["ShortText"] = 0] = "ShortText";
    /**
     * 长文本
     */
    DataItemType[DataItemType["LongText"] = 1] = "LongText";
    /**
    * 数值
    */
    DataItemType[DataItemType["Number"] = 2] = "Number";
    /**
     * 日期
     */
    DataItemType[DataItemType["Date"] = 3] = "Date";
    /**
     * 逻辑
     */
    DataItemType[DataItemType["Logic"] = 4] = "Logic";
    /**
     * 人员单选
     */
    DataItemType[DataItemType["StaffSingle"] = 50] = "StaffSingle";
    /**
     * 附件
     */
    DataItemType[DataItemType["Attachment"] = 6] = "Attachment";
    /**
     * 审批意见
     */
    DataItemType[DataItemType["ApprovalOpinion"] = 7] = "ApprovalOpinion";
    /**
     * 子表
     */
    DataItemType[DataItemType["Sheet"] = 8] = "Sheet";
    /**
     * 关联单选
     */
    DataItemType[DataItemType["RelevanceForm"] = 9] = "RelevanceForm";
    /**
     * 地理位置
     */
    DataItemType[DataItemType["Address"] = 10] = "Address";
    /**
     * 关联多选
     */
    DataItemType[DataItemType["RelevanceFormEx"] = 11] = "RelevanceFormEx";
    /**
     * 单选框
     */
    DataItemType[DataItemType["Radio"] = 12] = "Radio";
    /**
    * 复选框
    */
    DataItemType[DataItemType["Checkbox"] = 13] = "Checkbox";
    /**
     * 下拉框单选
     */
    DataItemType[DataItemType["Dropdown"] = 14] = "Dropdown";
    /**
     * 下拉框多选
     */
    DataItemType[DataItemType["DropdownMulti"] = 15] = "DropdownMulti";
    /**
     * 人员多选
     */
    DataItemType[DataItemType["StaffMulti"] = 51] = "StaffMulti";
    /**
     * 部门单选
     */
    DataItemType[DataItemType["DeptSingle"] = 60] = "DeptSingle";
    /**
     * 部门多选
     */
    DataItemType[DataItemType["DeptMulti"] = 61] = "DeptMulti";
    /**
     * 混合选人控件
     */
    DataItemType[DataItemType["StaffDeptMix"] = 5] = "StaffDeptMix";
    /**
     * 时间
     */
    DataItemType[DataItemType["Time"] = 20] = "Time";
})(DataItemType || (DataItemType = {}));
/**
 * 数据项类型文字
 */
export var DataItemTypeText;
(function (DataItemTypeText) {
    /**
     * 短文本
     */
    DataItemTypeText["ShortText"] = "\u77ED\u6587\u672C";
    /**
     * 长文本
     */
    DataItemTypeText["LongText"] = "\u957F\u6587\u672C";
    /**
     * 数值
     */
    DataItemTypeText["Number"] = "\u6570\u503C";
    /**
     * 日期
     */
    DataItemTypeText["Date"] = "\u65E5\u671F";
    /**
     * 逻辑
     */
    DataItemTypeText["Logic"] = "\u903B\u8F91";
    /**
     * 人员单选
     */
    DataItemTypeText["StaffSingle"] = "\u4EBA\u5458\u5355\u9009";
    /**
     * 附件
     */
    DataItemTypeText["Attachment"] = "\u9644\u4EF6";
    /**
     * 审批意见
     */
    DataItemTypeText["ApprovalOpinion"] = "\u5BA1\u6279\u610F\u89C1";
    /**
     * 子表
     */
    DataItemTypeText["Sheet"] = "\u5B50\u8868";
    /**
     * 关联单选
     */
    DataItemTypeText["RelevanceForm"] = "\u5173\u8054\u5355\u9009";
    /**
     * 地理位置
     */
    DataItemTypeText["Address"] = "\u5730\u7406\u4F4D\u7F6E";
    /**
     * 关联多选
     */
    DataItemTypeText["RelevanceFormEx"] = "\u5173\u8054\u591A\u9009";
    /**
     * 单选框
     */
    DataItemTypeText["Radio"] = "\u5355\u9009\u6846";
    /**
     * 复选框
     */
    DataItemTypeText["Checkbox"] = "\u590D\u9009\u6846";
    /**
     * 下拉框单选
     */
    DataItemTypeText["Dropdown"] = "\u4E0B\u62C9\u5355\u9009\u6846";
    /**
     * 下拉框多选
     */
    DataItemTypeText["DropdownMulti"] = "\u4E0B\u62C9\u591A\u9009\u6846";
    /**
     * 人员多选
     */
    DataItemTypeText["StaffMulti"] = "\u4EBA\u5458\u591A\u9009";
    /**
     * 部门单选
     */
    DataItemTypeText["DeptSingle"] = "\u90E8\u95E8\u5355\u9009";
    /**
     * 部门多选
     */
    DataItemTypeText["DeptMulti"] = "\u90E8\u95E8\u591A\u9009";
    /**
     * 混合选人控件
     */
    DataItemTypeText["StaffDeptMix"] = "\u6DF7\u5408\u9009\u4EBA";
    /**
     * 时间
     */
    DataItemTypeText["Time"] = "\u65F6\u95F4";
})(DataItemTypeText || (DataItemTypeText = {}));
/**
 * 数据项类型顔色
 */
export var DataItemTypeColor;
(function (DataItemTypeColor) {
    /**
     * 短文本
     */
    DataItemTypeColor["ShortText"] = "#FCE3E2";
    /**
     * 长文本
     */
    DataItemTypeColor["LongText"] = "#FCE3E2";
    /**
     * 数值
     */
    DataItemTypeColor["Number"] = "#CEF5DC";
    /**
     * 日期
     */
    DataItemTypeColor["Date"] = "#DEF8C6";
    /**
     * 逻辑
     */
    DataItemTypeColor["Logic"] = "#ECF5BB";
    /**
     * 人员单选
     */
    DataItemTypeColor["StaffSingle"] = "#D1EEFC";
    /**
     * 附件
     */
    DataItemTypeColor["Attachment"] = "#FFE8DA";
    /**
     * 审批意见
     */
    DataItemTypeColor["ApprovalOpinion"] = "#ECF5BB";
    /**
     * 子表
     */
    DataItemTypeColor["Sheet"] = "#FCDEF5";
    /**
     * 关联单选
     */
    DataItemTypeColor["RelevanceForm"] = "#D3F1F1";
    /**
     * 地理位置
     */
    DataItemTypeColor["Address"] = "#FCE8C1";
    /**
     * 关联多选
     */
    DataItemTypeColor["RelevanceFormEx"] = "#D3F1F1";
    /**
     * 单选框
     */
    DataItemTypeColor["Radio"] = "#ECD7F8";
    /**
     * 复选框
     */
    DataItemTypeColor["Checkbox"] = "#ECD7F8";
    /**
     * 下拉框单选
     */
    DataItemTypeColor["Dropdown"] = "#DDE2EA";
    /**
     * 下拉框多选
     */
    DataItemTypeColor["DropdownMulti"] = "#DDE2EA";
    /**
     * 人员多选
     */
    DataItemTypeColor["StaffMulti"] = "#D1EEFC";
    /**
     * 部门单选
     */
    DataItemTypeColor["DeptSingle"] = "#DDE8FF";
    /**
     * 部门多选
     */
    DataItemTypeColor["DeptMulti"] = "#DDE8FF";
    /**
     * 混合选人控件
     */
    DataItemTypeColor["StaffDeptMix"] = "#D1EEFC";
    /**
     * 时间
     */
    DataItemTypeColor["Time"] = "#D5F8D1";
})(DataItemTypeColor || (DataItemTypeColor = {}));
export const DataItemTypeValue = {
    ShortText(val, type) {
        return str(val, type);
    },
    LongText(val, type) {
        return str(val, type);
    },
    Number(val, type) {
        if (typeof val === "number") {
            return val;
        }
        else if (/^[0-9]+.?[0-9]*$/.test(val)) {
            return +val;
        }
        valError(val, type, "数值");
    },
    Logic(val, type) {
        if (typeof val === "boolean") {
            return val;
        }
        else if (val === "true") {
            valError(val, type, "逻辑");
            return true;
        }
        else if (val === "false") {
            valError(val, type, "逻辑");
            return false;
        }
    },
    Date(val, type) {
        if (val instanceof Date) {
            return val;
        }
        else if (typeof val === "string" && val) {
            try {
                let str = val
                    .replace(/-/g, "/") // iOS兼容
                    .replace(/T/g, " "); //修复2019-09-17T06:21:07.000字符不能new Date的问题
                let date = new Date(str);
                if (date.getFullYear() > 0) {
                    return date;
                }
            }
            catch (_a) { }
        }
        valError(val, type, "日期");
    },
    StaffSelector(val, type) {
        return strOrArray(val, type);
    },
    Attachment(val, type) {
        return strOrArray(val, type);
    },
    ApprovalOpinion(val, type) { },
    Sheet(val, type) {
        return strOrArray(val, type);
    },
    RelevanceForm(val, type) {
        return strOrObject(val, type);
    },
    Address(val, type) {
        return strOrObject(val, type);
    },
};
function str(val, type) {
    if (typeof val === "string") {
        return val;
    }
    else if (typeof val === "number") {
        return "" + val;
    }
    valError(val, type, "字符串");
}
function strOrArray(val, type) {
    if (typeof val === "string") {
        try {
            val = JSON.parse(val);
        }
        catch (_a) {
            /* console.log(`${type} 类型值解析错误! 值是: ${val}`); */
        }
    }
    if (Array.isArray(val) && val.some((x) => typeof x === "object")) {
        return val;
    }
}
function strOrObject(val, type) {
    if (typeof val === "string") {
        try {
            val = JSON.parse(val);
        }
        catch (_a) {
            /* console.log(`${type} 类型值解析错误! 值是: ${val}`); */
        }
    }
    if (typeof val === "object") {
        return val;
    }
}
function valError(val, type, valType) {
    console.error(`${type} 类型的控件值应该 ${valType}类型,但是它现在是 ${typeof val}`);
}
